import { Resource } from '@/japi/types/Resource'

// Creates a guard that narrows a resource to `T` by its JSON:API `type`, e.g. `isResourceOfType<PersonResource>('people')`
export const isResourceOfType = <T extends Resource>(type: T['type']) => (
    (resource: Resource): resource is T => resource.type === type
)
